<tabset class="nav nav-tabs admin-tab cs-primary-tabs cs-order-primary-tabs" #orderTabs>

    <tab autofocus class="padding0" id="order-promotion"  heading="{{'customer-service.New POS Order' |translate |translateKey}}" >
        <div class="container">
            <pos-order-promotion></pos-order-promotion>
        </div>
    </tab>
    <tab autofocus class="dynamic-tab padding0" *ngFor="let tab of orderHistoryTabs" [heading]="tab.title" [active]="tab.active"
    (select)="tab.active = true;" (deselect)="tab.active = false" [disabled]="tab.disabled" [removable]="tab.removable" (removed)="removeOrderTab(tab)">
    <recent-order-view *ngIf="tab.componentName == 'orderViewTab'" [orderInfo]="tab"></recent-order-view>
     </tab>
    <tab *ngIf="isEditOrders" id="order-edit" autofocus class="dynamic-tab padding0" heading="Edit Order" [active]="activeTab === 2"
        (select)="active = true;" (deselect)="active = false" [disabled]="disabled" [removable]="true">
        <div class="container">
            <order-edit [webOrderId]="webOrderId"></order-edit>
        </div>
    </tab> 
</tabset>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/pos-orders/pos-order-tabs.component.html